import { Route } from 'react-router-dom'
import { Routes } from 'react-router'
import Home from '../Pages/Home'
import Solar from '../Pages/Solar'

function MainRoute() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/solar" element={<Solar />} />
      <Route path="/pizza" element={<>Coming soon</>} />
    </Routes>
  )
}

export default MainRoute
